import { render, staticRenderFns } from "./PrintDetail.vue?vue&type=template&id=a94f9518&scoped=true&"
import script from "./PrintDetail.vue?vue&type=script&lang=ts&"
export * from "./PrintDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94f9518",
  null
  
)

export default component.exports